module.exports = __webpack_public_path__ + "img/HQ-OA-360V02TGL_ALL.a5957b90.jpg";